import { createComputed, createSignal, Match, Show, Switch } from "solid-js"
import { A, useParams } from "@solidjs/router"
import { v4 as uuidv4 } from "uuid"
import { DataTypes, Media, MediaTypes, useLocalStore } from "@/context/StateContext"
import Editor from "@/components/Editor"
import Types from "@/types"

export default function MediaDetailView() {
  const params = useParams()
  const [mediaId, setMediaId] = createSignal(params.id)
  createComputed(() => setMediaId(params.id))

  const localStore = useLocalStore()

  const [media, setMedia] = createSignal<Media | null>(null)
  createComputed(async () => {
    if (!mediaId() || !localStore.database) return
    const res = await localStore.database.find({
      selector: {
        origin: mediaId()
      }
    })
    const connections = res.docs
    const doc: any = {}
    connections.forEach((connection: any) => {
      doc[connection.type] = connection.target
    })

    const serverUrl = `https://media.trettin.org:8443/api/blobs/download/stuff`
    doc.original = `${serverUrl}/${localStore.activeUserId}/${mediaId()}/${Types.Original}`

    setMedia(doc)
  })

  return (
    <div class="flex flex-col flex-1 overflow-hidden">
      <Switch fallback={<div class="flex items-center justify-center h-full">Something went wrong</div>}>
        <Match when={media()?.[Types.MediaType] === MediaTypes.Image}>
          <div class="flex items-center justify-center w-full h-full overflow-auto">
            <img
              class="max-w-full max-h-full object-contain"
              src={media()?.original}
            />
          </div>
        </Match>
        <Match when={media()?.[Types.MediaType] === MediaTypes.Video}>
          <div class="flex items-center justify-center w-full h-full overflow-auto">
            <video
              class="max-w-full max-h-full object-contain"
              src={media()?.original}
              controls
              playsinline
            />
          </div>
        </Match>
        <Match when={media()?.[Types.MediaType] === MediaTypes.Audio}>
          <div class="flex items-center justify-center w-full h-full">
            <audio src={media()?.original} controls class="w-full max-w-md" />
          </div>
        </Match>
        <Match when={media()?.[Types.MediaType] === MediaTypes.Document}>
          <div class="flex w-full h-full">
            <object data={media()?.original} type="application/pdf" class="w-full h-full">
              <p>Document not found</p>
            </object>
          </div>
        </Match>
        <Match when={media()?.[Types.MediaType] === MediaTypes.Other}>
          <div class="flex items-center justify-center w-full h-full">
            <div>Other media type</div>
          </div>
        </Match>
      </Switch>
    </div>
  )
}
